<section class="services-section py-5 bg-light" id="services">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 mx-auto text-center mb-5">
        <h2 class="section-title">{{ i18n.getTranslation('services.title') }}</h2>
        <p class="section-subtitle text-muted">{{ i18n.getTranslation('services.subtitle') }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-6 mb-4" *ngFor="let service of services">
        <div class="service-card h-100">
          <div class="service-icon">
            <i [class]="service.icon"></i>
          </div>
          <div class="service-content">
            <h4 class="service-title">{{ service.title }}</h4>
            <p class="service-description">{{ service.description }}</p>
            <ul class="service-features">
              <li *ngFor="let feature of service.features">
                <i class="fas fa-check text-primary me-2"></i>
                {{ feature }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <div class="row mt-5">
      <div class="col-lg-8 mx-auto text-center">
        <div class="cta-section">
          <h3 class="cta-title">Ready to Start Your Project?</h3>
          <p class="cta-description">Let's discuss how I can help bring your ideas to life</p>
          <a href="#contact" class="btn btn-primary btn-lg">
            <i class="fas fa-envelope me-2"></i>
            Get In Touch
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
